import React from "react";
import { Col, Row } from "react-bootstrap";

const NewProductDetailsSection = (props: any) => {
  const { data } = props;

  return (
    <div className="new-product-details-container">
      <div className="new-product-details-inner-wrapper">
        <div className="new-product-details-heading">The Whisky </div>

        <div className="new-product-details-outerwrapper">
          <Row className="product-gap">
            {data?.items?.map((item: any, index: number) => {
              return (
                <Col xs={12} md={6} key={index} className="list-wrapper">
                  <Row>
                    <Col xs={6} md={6}>
                      <div className="icon-title-wrapper">

                        <img src={item?.logo?.data?.attributes?.url} />
                        <h2>{item?.title}</h2>
                      </div>
                    </Col>
                    <Col xs={6} md={6} className="icon-title-wrapper">
                      <h3>{item?.details}</h3>
                    </Col>
                  </Row>
                </Col>
              );
            })}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default NewProductDetailsSection;
